/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('quote-carousel', function (el) {
        MoyaLoader.all([
            'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
            'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
        ]).then(function () {
            el.querySelector('.quotes').classList.add('swiper-container');
            el.querySelector('.wrapper').classList.add('swiper-wrapper');
            el.querySelectorAll('figure').forEach(function (quote) {
                quote.classList.add('swiper-slide');
            });
            var parameters = {
                direction: 'horizontal',
                slidesPerView: 1,
            };
            if (el.dataset.controls === 'nav') {
                var buttonPrev = document.createElement('button');
                buttonPrev.classList.add('swiper-button', 'swiper-button-prev');
                el.append(buttonPrev);
                var buttonNext = document.createElement('button');
                buttonNext.classList.add('swiper-button', 'swiper-button-next');
                el.append(buttonNext);
                parameters['navigation'] = {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                };
            }
            else if (el.dataset.controls === 'pagination') {
                var pagination = document.createElement('div');
                pagination.classList.add('swiper-pagination');
                el.append(pagination);
                parameters['pagination'] = {
                    el: ".swiper-pagination",
                };
            }
            if (document.documentElement.lang === 'is') {
                parameters['a11y'] = {
                    prevSlideMessage: 'Fyrri',
                    nextSlideMessage: 'Næsta',
                };
            }
            new Swiper('#' + el.closest('.box').getAttribute('id') + ' .quotes', parameters);
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
